import { render, staticRenderFns } from "./OrderDenominationalFormComponent.vue?vue&type=template&id=a6198fc0&"
import script from "./OrderDenominationalFormComponent.vue?vue&type=script&lang=js&"
export * from "./OrderDenominationalFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports